/**
 * @file
 * This file control the querystring used on EPC.
 */
(function ($, Drupal) {
  'use strict';

  var cookieEpcQuery = 'ethicon_epc_qs';

  Drupal.behaviors.jnjethicon_product_localization_control_query = {

    attach: function () {
      this.init();
    },

    init: function(newLang) {
      var utils = Drupal.jnjethicon_product_localization_utils;

      // Get EPC cookie.
      var cookieQuery = utils.getCookie(cookieEpcQuery);
      var langCountry = utils.getParameterByName('lang');

      if (newLang && newLang.length > 0) {
        langCountry = newLang;
      }

      this.setCookie(langCountry, cookieQuery, utils);
    },

    setCookie: function (langCountry, cookieQuery, utils) {
      if ((langCountry.length > 0) && (langCountry != cookieQuery || !cookieQuery)) {
        utils.setCookie(cookieEpcQuery, langCountry);
      }
    }

};

})(jQuery, Drupal);

